import React, {useState }from 'react';
import axios from '../../../utils/axios';
import { useHistory } from 'react-router-dom';
import './dash-container.scss';
import { CreateReportAccordion,ReporttabListing } from '..';
import { default as t } from '../../../utils/i18n';
import fileDownload from 'js-file-download'
import config from '../../../utils/config';
import axiosStat from "axios";
const HELP_SUPPORT_LINK = config.get('help', 'support_link');
const DashContainer = props => {
  const history = useHistory();
  const [onUpdateTable, setOnUpdateTable] = useState(false);


  const onTableRowclicked = (event) => {
    if(event) {
        history.push('/'+event.reportId);
    };
  }

  const handleDownload = (url, filename) => {
    const userGuideUrl = url.replace(/\{(.*?)\}/gi,t('dashboard.link.helpAndSupport',true));
    const api = axiosStat.create({
      baseURL: axios.defaults.baseURL.slice(0,-4),
     });
     api.get(userGuideUrl, {
        responseType: 'blob',
    })
        .then((res) => {
            fileDownload(res.data, filename)
        })
}
  const evUpdateTableListing = (event) => {
    setOnUpdateTable(true);
    setTimeout(() => {
      setOnUpdateTable(false);
    }, 500);
  }

  return (
    <section className={`report-container` }>
      <div className='header-container'>
        <div className='header-holder'>
        <h2>{t('insights.report.list.heading')}</h2>
      <p>{t('insights.report.list.subheading')}</p>
        </div>
        <div className="ques-instruction">
                        <span>{t('download.pdf.info.question')}</span>
                        <button onClick={() => { handleDownload( HELP_SUPPORT_LINK, 'help.pdf') }} className="download">
                            <i className="eva eva-message-circle-outline"></i>
                            {t('download.pdf.button.label')}
                        </button>
                        
                    </div>
      </div>
     
      <CreateReportAccordion evUpdateTableListing={evUpdateTableListing}/> 
      <ReporttabListing onTableRowclicked={onTableRowclicked} onUpdateTable = {onUpdateTable}/>
      {/* {showAttributeTable && tableRowData ? <AttributeDetailListing tableRowData={tableRowData}  handleBackClick ={handleBackClick}/> : null} */}
  
    </section>
  );
};

export default DashContainer;
